<div class="container" id="resetPassword">
    <div class="title">Reset password</div>
    <ng-container [ngSwitch]="passwordResetState">
        <ng-container *ngSwitchDefault>
            <div class="label">Enter new password</div>
            <app-input
                inputType="password"
                [control]="password"
                class="rounded-input"
                placeholder="New Password *"
                [error]="password | inputError | async"
            ></app-input>
            <button class="app-raised-button mt-5" [disabled]="password.invalid" type="raised" (click)="submit()">
                <span *ngIf="passwordResetState !== 'LOADING'">Reset Password</span>
                <mat-spinner [diameter]="20" *ngIf="passwordResetState === 'LOADING'"></mat-spinner>
            </button>
        </ng-container>
        <ng-container *ngSwitchCase="'ERROR'">
            <div class="label text-danger">{{ error }}</div>
        </ng-container>
        <ng-container *ngSwitchCase="'SUCCESS'">
            <div class="label text-success">Password was reset successfully. Please login!</div>
            <button class="app-raised-button mt-5" (click)="login()">Login</button>
        </ng-container>
    </ng-container>
</div>
